"use client";

// packages/eden-icons/src/generated-from-source/Send.jsx
import styled from "styled-components";
import { jsx, jsxs } from "react/jsx-runtime";
var SVG = styled.svg`
  min-width: ${({ $size }) => $size};
  max-width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
`;
var Send = ({ size = "1em", color = "currentColor", title, ...props }) => /* @__PURE__ */ jsxs(SVG, { ...props, $size: size, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", role: title ? "img" : "presentation", children: [
  title ? /* @__PURE__ */ jsx("title", { children: title }) : null,
  " ",
  /* @__PURE__ */ jsx("path", { fill: color, d: "M3.694 11.995 1.52 19.967a.548.548 0 0 0 .736.651l19.92-8.115a.548.548 0 0 0 0-1.015L2.256 3.372a.548.548 0 0 0-.736.651zm1.261-1.625a.5.5 0 0 0 .415.364l7.291.994c.316.043.316.5 0 .543l-7.294.994a.5.5 0 0 0-.414.364L3.69 18.26l15.375-6.264L3.69 5.731z", fillRule: "evenodd", clipRule: "evenodd", children: " " })
] });
var Send_default = Send;
export {
  Send_default as default
};
